<template>
  <div v-show="isLoaded" class="dMixologiaRose-container" v-observe-visibility="startAnimate">
    <h2 class="dSection-title" :class="{animate: animate}">
      Mixología
    </h2>
    <h2 class="dSection-subtitle" :class="{animate: animate}">
      Vuélvete mixólogo con strongbow y agrega un toque de ingredientes naturales para crear una experiencia nueva de sabor.
    </h2>
    <div class="dSection-videos">
      <div class="dLeft-col">
        <div id="videoRose1" class="video-left"></div>
        <h3>SPICY KICK</h3>
        <h4>Doble estímulo picante con chile de árbol puro y jengibre cristalizado casados vía fresco jugo de limón y un ligero dulzor con miel de agave azul.</h4>
      </div>
      <div class="dRight-col">
        <div id="videoRose2" class="video-right"></div>
        <h5>ROSÉ BOUQUET</h5>
        <h6>Isotipos de vino rosado juegan con la untuosidad de aceite de naranja y texturas naturales de flores de jazmín para una aventura romántica.</h6>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser";
import YouTubePlayer from 'youtube-player';
import tagFunctions from "@/utils/tagFunctions.js";

let timer, percent = 0, quartileTime

export default {
  name: "D_MixologiaRose",
  components: {},
  data() {
    return {
      video1: null,
      video2: null,
      animate: false,
      isSafari: false,
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    },
    record(event) {
      let currentTime = Math.round(event.target.getCurrentTime());
      percent = getPercent(event);
      if (currentTime == quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "25"
        );
      }
      if (currentTime == 2 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "50"
        );
      }
      if (currentTime == 3 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "75"
        );
      }
      if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "100"
        );
      }
      function getPercent(event) {
        return Math.round(
          (event.target.getCurrentTime() / event.target.getDuration()) * 100
        );
      }
    },
    onPlayerStateChange(event) {
      quartileTime = Math.round(event.target.getDuration() / 4);
      const getQuartile = () => {
        if (percent <= 25) return 25;
        else if (percent > 25 && percent <= 50) return 50;
        else if (percent > 50 && percent <= 75) return 75;
        else return 100;
      };
      if (event.data == window.YT.PlayerState.PLAYING) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile())
        timer = setInterval(() => {
          this.record(event);
        }, 1000);
      } else {
        clearInterval(timer);
      }
      if (event.data == window.YT.PlayerState.ENDED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile()) 
      }
      if (event.data == window.YT.PlayerState.PAUSED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile())
      }
    },
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
  mounted() {
    this.video1 = YouTubePlayer('videoRose1', {videoId: 'tpkN9jfNsUM', width: '560', height: '315'})
    this.video1.on('stateChange', this.onPlayerStateChange)
    this.video2 = YouTubePlayer('videoRose2', {videoId: 'JAOjjz5pkoY', width: '560', height: '315'})
    this.video2.on('stateChange', this.onPlayerStateChange)
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RoseApple/D_MixologiaRose.scss";
</style>